module.exports = __webpack_public_path__ + "static/media/pause-icon-white.dd3d9d32.svg";